// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.show-search-conditions-pop .show-search-conditions-tags {
  display: -webkit-inline-flex;
  display: inline-flex;
  overflow: hidden;
  max-width: 320px;
  min-width: 40px;
  text-align: left;
  word-break: break-all;
  margin: 4px 4px;
  color: #666;
  border-color: #DBE0E5;
  background-color: transparent;
  border-radius: 3px;
}
.show-search-conditions-pop .show-search-conditions-tags .wui-tag-text {
  -webkit-flex-shrink: 1;
          flex-shrink: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.show-search-conditions-pop .show-search-conditions-tags .uf-close {
  color: #ADB4BC;
}
.refer-picker-body.wui-modal-body {
  padding: 0;
}
.refer-search-container {
  padding: 10px 24px 12px;
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
}
.refer-search-container .refer-search-input {
  width: 300px;
}
.refer-search-container .refer-search-backbtn {
  margin-left: 10px;
}
.refer-search-container .refer-search-checkbox {
  margin-left: 10px;
}
.refer-search-container .dropdown-btn {
  margin-left: 8px;
}
.ref-view .wui-layout.tree-table-layout-collapsed {
  height: 100%;
}
.refer-table-list {
  height: 100%;
  overflow: auto;
}
.refer-table-list::-webkit-scrollbar {
  width: 8px;
}
.refer-table-list::-webkit-scrollbar-thumb {
  width: 8px;
  height: 121px;
  background: #CDD9E6;
  border-radius: 4px;
}
.refer-table-list .yb-table {
  height: calc(100% - 84px);
}
.refer-table-list .yb-table .complex-table {
  border-bottom: none;
}
.refer-table-list .yyrefer-popover .yb-table > div:first-child {
  max-height: 390px;
}
.refer-table-list .tree-single-text {
  background: #f7f9fd;
  border-radius: 4px;
  line-height: 1;
  margin: 8px 20px 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 7px;
  white-space: nowrap;
  color: #333;
}
.refer-table-list .tree-single-text .unselect {
  color: #999;
}
.refer-table-list .adm-empty,
.refer-table-list .adm-list {
  -webkit-flex: 1 1;
          flex: 1 1;
}
.refer-table-list .adm-list {
  height: calc(100% - 110px);
}
.refer-table-list .adm-list-body {
  height: 100%;
}
.refer-table-list .adm-list-body-inner {
  height: 100%;
  overflow: auto;
}
.refer-table-list .flex-wrap {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
          justify-content: space-between;
}
.refer-table-list .flex-wrap .wui-pagination {
  min-width: auto;
}
.refer-table-list .flex-wrap .table-selected-rows-content {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
          align-items: center;
  line-height: 34px;
  padding-left: 10px;
  white-space: nowrap;
}
.refer-table-list .flex-wrap .table-selected-rows-content .table-selected-rows-switch {
  margin-right: 6px;
}
.refer-table-list .wui-table-row-hover .uf-star-o {
  display: block;
}
.refer-table-list .uf-star-o {
  font-size: 15px !important;
  color: #f7c400;
  display: none;
}
.tree-table-layout-collapsed {
  box-shadow: 2px 2px 5px #f1f1f1;
}
.tree-table-layout-collapsed .site-layout {
  border-left: 1px solid #f0f2f5;
}
.tree-table-layout-collapsed .sider-container {
  border-right: 1px solid #d9d9d9;
}
.tree-table-layout-collapsed .my-trigger {
  position: absolute;
  top: 20px;
  right: 0;
  background-color: #dedede;
  color: #fff;
  line-height: 24px;
  width: 12px;
  cursor: pointer;
}
.tree-table-layout-collapsed .my-trigger > .uf {
  padding: 0;
  font-size: 12px;
}
.ynf-refer-tabs {
  height: 100%;
}
.ynf-refer-tabs .wui-tabs-content {
  height: calc(100% - 30px);
}
.ynf-refer-tabs .wui-tabs-bar {
  margin-bottom: 0 !important;
}
.ynf-refer-tabs .wui-tabs-tabpane {
  display: block;
  height: 100%;
}
.refer-dropdown-list {
  max-height: 350px;
  overflow: auto;
  padding: 8px 0;
}
.refer-dropdown-list .list-item {
  height: 32px;
  padding: 0 12px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  -webkit-align-items: center;
          align-items: center;
  font-size: 12px;
  color: #111;
  cursor: pointer;
}
.refer-dropdown-list .list-item:hover {
  background: #F0F0F0;
}
.refer-dropdown-list .list-item .uf-correct-2 {
  font-size: 10px;
  font-weight: bold;
  color: #EE2223;
}
.refer-dropdown-list .loading {
  font-size: 12px;
  color: #999;
  padding: 0 12px;
}
.refer-dropdown-list::-webkit-scrollbar {
  width: 8px;
}
.refer-dropdown-list::-webkit-scrollbar-thumb {
  width: 8px;
  height: 121px;
  background: #CDD9E6;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/index.less","webpack://./src/components/ReferList/style/index.less"],"names":[],"mappings":"AAOA;EAEI,4BAAA;EAAA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,kBAAA;ACPJ;ADLA;EAeM,sBAAA;UAAA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;ACPN;ADXA;EAsBM,cAAA;ACRN;AAXA;EACE,UAAA;AAaF;AAVA;EACE,uBAAA;EACA,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;AAYF;AAfA;EAMI,YAAA;AAYJ;AAlBA;EAUI,iBAAA;AAWJ;AArBA;EAcI,iBAAA;AAUJ;AAxBA;EAkBI,gBAAA;AASJ;AALA;EAEI,YAAA;AAMJ;AAFA;EACE,YAAA;EACA,cAAA;AAIF;AAFE;EACE,UAAA;AAIJ;AAAE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAEJ;AAfA;EAqBI,yBAAA;AAHJ;AAlBA;EAwBM,mBAAA;AAHN;AArBA;EA6BI,iBAAA;AALJ;AAxBA;EAiCI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AANJ;AAnCA;EA4CM,WAAA;AANN;AAtCA;;EAiDI,iBAAA;UAAA,SAAA;AAPJ;AA1CA;EAoDI,0BAAA;AAPJ;AA7CA;EAuDI,YAAA;AAPJ;AAhDA;EA0DI,YAAA;EACA,cAAA;AAPJ;AApDA;EA+DI,qBAAA;EAAA,aAAA;EACA,sCAAA;UAAA,8BAAA;AARJ;AAxDA;EAmEM,eAAA;AARN;AA3DA;EAuEM,qBAAA;EAAA,aAAA;EACA,2BAAA;UAAA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AATN;AAlEA;EA8EQ,iBAAA;AATR;AArEA;EAoFI,cAAA;AAZJ;AAxEA;EAwFI,0BAAA;EACA,cAAA;EACA,aAAA;AAbJ;AAiBA;EACE,+BAAA;AAfF;AAcA;EAII,8BAAA;AAfJ;AAWA;EAQI,+BAAA;AAhBJ;AAQA;EAYI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AAjBJ;AAFA;EAsBM,UAAA;EACA,eAAA;AAjBN;AAsBA;EACE,YAAA;AApBF;AAmBA;EAII,yBAAA;AApBJ;AAgBA;EAQI,2BAAA;AArBJ;AAaA;EAYI,cAAA;EACA,YAAA;AAtBJ;AA0BA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;AAxBF;AAqBA;EAMI,YAAA;EACA,eAAA;EACA,qBAAA;EAAA,aAAA;EACA,sCAAA;UAAA,8BAAA;EACA,2BAAA;UAAA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAxBJ;AA0BI;EACE,mBAAA;AAxBN;AAQA;EAoBM,eAAA;EACA,iBAAA;EACA,cAAA;AAzBN;AAGA;EA2BI,eAAA;EACA,WAAA;EACA,eAAA;AA3BJ;AA+BE;EACE,UAAA;AA7BJ;AA8CE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AA5CJ","sourcesContent":["// 样式变量定义\n// @theme: #f53c32;\n\n// 公共样式\n// body{\n//     background-color: #ffffff;\n// }\n.show-search-conditions-pop {\n  .show-search-conditions-tags {\n    display: inline-flex;\n    overflow: hidden;\n    max-width: 320px;\n    min-width: 40px;\n    text-align: left;\n    word-break: break-all;\n    margin: 4px 4px;\n    color: #666;\n    border-color: #DBE0E5;\n    background-color: transparent;\n    border-radius: 3px;\n\n    .wui-tag-text {\n      flex-shrink: 1;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    .uf-close {\n      color: #ADB4BC;\n    }\n  }\n}","@import '../../../assets/style/index.less';\n\n// .arc-navbar {\n//   box-shadow: 0px 1px 5px #eee;\n// }\n\n// .adm-list-item {\n//   padding-left: 0;\n// }\n\n.refer-picker-body.wui-modal-body {\n  padding: 0;\n}\n\n.refer-search-container {\n  padding: 10px 24px 12px;\n  display: flex;\n  align-items: center;\n\n  .refer-search-input {\n    width: 300px;\n  }\n\n  .refer-search-backbtn {\n    margin-left: 10px;\n  }\n\n  .refer-search-checkbox {\n    margin-left: 10px;\n  }\n\n  .dropdown-btn {\n    margin-left: 8px;\n  }\n}\n\n.ref-view {\n  .wui-layout.tree-table-layout-collapsed {\n    height: 100%;\n  }\n}\n\n.refer-table-list {\n  height: 100%;\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  //滚动条里面可以拖动的那个\n  &::-webkit-scrollbar-thumb {\n    width: 8px;\n    height: 121px;\n    background: #CDD9E6;\n    border-radius: 4px;\n  }\n\n  // .wui-radio-group.table-radio {\n  //   line-height: 23px !important;\n  // }\n\n  .yb-table {\n    height: calc(100% - 84px);\n\n    .complex-table {\n      border-bottom: none;\n    }\n  }\n\n  .yyrefer-popover .yb-table > div:first-child {\n    max-height: 390px;\n  }\n\n  .tree-single-text {\n    background: #f7f9fd;\n    border-radius: 4px;\n    line-height: 1;\n    margin: 8px 20px 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 7px;\n    white-space: nowrap;\n    color: #333;\n\n    .unselect {\n      color: #999;\n    }\n  }\n\n  .adm-empty, .adm-list {\n    flex: 1;\n  }\n  .adm-list {\n    height: calc(100% - 110px);\n  }\n  .adm-list-body {\n    height: 100%;\n  }\n  .adm-list-body-inner {\n    height: 100%;\n    overflow: auto;\n  }\n\n  .flex-wrap {\n    display: flex;\n    justify-content: space-between;\n  \n    .wui-pagination {\n      min-width: auto;\n    }\n  \n    .table-selected-rows-content {\n      display: flex;\n      align-items: center;\n      line-height: 34px;\n      padding-left: 10px;\n      white-space: nowrap;\n  \n      .table-selected-rows-switch {\n        margin-right: 6px;\n      }\n    }\n  }\n\n  .wui-table-row-hover .uf-star-o {\n    display: block;\n  }\n\n  .uf-star-o {\n    font-size: 15px !important;\n    color: #f7c400;\n    display: none;\n  }\n}\n\n.tree-table-layout-collapsed {\n  box-shadow: 2px 2px 5px #f1f1f1;\n\n  .site-layout {\n    border-left: 1px solid #f0f2f5;\n  }\n\n  .sider-container {\n    border-right: 1px solid rgb(217, 217, 217);\n  }\n\n  .my-trigger {\n    position: absolute;\n    top: 20px;\n    right: 0;\n    background-color: #dedede;\n    color: #fff;\n    line-height: 24px;\n    width: 12px;\n    cursor: pointer;\n\n    >.uf{\n      padding: 0;\n      font-size: 12px;\n    }\n  }\n}\n\n.ynf-refer-tabs {\n  height: 100%;\n  \n  .wui-tabs-content {\n    height: calc(100% - 30px);\n  }\n\n  .wui-tabs-bar {\n    margin-bottom: 0 !important;\n  }\n\n  .wui-tabs-tabpane {\n    display: block;\n    height: 100%;\n  }\n}\n\n.refer-dropdown-list {\n  max-height: 350px;\n  overflow: auto;\n  padding: 8px 0;\n\n  .list-item {\n    height: 32px;\n    padding: 0 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n    color: #111;\n    cursor: pointer;\n    \n    &:hover {\n      background: #F0F0F0;\n    }\n\n    .uf-correct-2 {\n      font-size: 10px;\n      font-weight: bold;\n      color: #EE2223;\n    }\n  }\n\n  .loading {\n    font-size: 12px;\n    color: #999;\n    padding: 0 12px;\n  }\n\n  //滚动条整体部分\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  //滚动条两端的按钮\n  &::-webkit-scrollbar-button {\n\n  }\n\n  // 外层轨道\n  &::-webkit-scrollbar-track {}\n\n  //内层轨道，滚动条中间部分（除去）\n  &::-webkit-scrollbar-track-piece {\n    \n  }\n\n  //滚动条里面可以拖动的那个\n  &::-webkit-scrollbar-thumb {\n    width: 8px;\n    height: 121px;\n    background: #CDD9E6;\n    border-radius: 4px;\n  }\n\n  //边角\n  &::-webkit-scrollbar-corner {}\n\n  //定义右下角拖动块的样式\n  &::-webkit-resizer {}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
